import SessionWizard from './SessionWizard.jsx';
import { quarterlyReview } from '../api/client.js';

function currentQuarterStart() {
  const d = new Date();
  const qStartMonth = Math.floor(d.getMonth() / 3) * 3;
  const start = new Date(d.getFullYear(), qStartMonth, 1);
  start.setHours(0, 0, 0, 0);
  return start.toISOString().slice(0, 10);
}

function quarterLabel(dateStr) {
  const d = dateStr ? new Date(dateStr) : new Date();
  const q = Math.floor(d.getMonth() / 3) + 1;
  return `Q${q} ${d.getFullYear()}`;
}

const config = {
  sessionType: 'quarterly',
  start: {
    title: 'Quarterly review',
    description:
      'Deeper retrospective. Walk through every role, then generate a single synthesised quarterly review.',
    buttonLabel: `Start new ${quarterLabel()} review`,
    inProgressLabel: 'In-progress quarterly reviews',
    resumeDateLabel: 'Quarter starting',
  },
  startDate: currentQuarterStart,
  summarise: quarterlyReview,
  hasSummary: (s) => !!s.quarterly_summary,
  renderSummary: (s) => (
    <div className="space-y-1">
      <div className="text-xs uppercase tracking-wide text-slate-400">Quarterly review</div>
      <div className="text-sm text-slate-800 whitespace-pre-wrap leading-relaxed">
        {s.quarterly_summary}
      </div>
    </div>
  ),
  summary: {
    heading: 'AI quarterly review',
    generateLabel: 'Generate quarterly review',
    generatingLabel: 'Generating',
    regenerateLabel: 'Regenerate',
    regeneratingLabel: 'Regenerating',
    emptyTitle: 'Generate quarterly review',
    emptyHint:
      'Sends every answer + voice transcript from this quarterly session to Claude. Produces a single markdown review covering recap, per-role takeaways, decisions, priorities, and goals to track.',
    weekLabel: 'Quarter starting',
  },
};

export default function QuarterlyWizard() {
  return <SessionWizard config={config} />;
}
